var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotdotdot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 25,
    viewBox: "0 0 45 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.15625,
    y: 0.980347,
    width: 42.5,
    height: 23,
    rx: 3.5,
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 19.5,
    height: 16.3125,
    transform: "translate(12.6562 4.3241)",
    fill: "white",
    fillOpacity: 0.01
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4300_47826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9062 14.1366C14.4354 14.1366 13.9879 13.9572 13.6612 13.6441C13.3352 13.3316 13.1562 12.9126 13.1562 12.4803C13.1562 12.0481 13.3352 11.629 13.6612 11.3166C13.9879 11.0035 14.4354 10.8241 14.9062 10.8241C15.3771 10.8241 15.8246 11.0035 16.1513 11.3166C16.4773 11.629 16.6562 12.0481 16.6562 12.4803C16.6562 12.9126 16.4773 13.3316 16.1513 13.6441C15.8246 13.9572 15.3771 14.1366 14.9062 14.1366ZM22.4062 14.1366C21.9354 14.1366 21.4879 13.9572 21.1612 13.6441L20.8153 14.005L21.1612 13.6441C20.8352 13.3316 20.6562 12.9126 20.6562 12.4803C20.6562 12.0481 20.8352 11.629 21.1612 11.3166L20.8186 10.9591L21.1612 11.3166C21.4879 11.0035 21.9354 10.8241 22.4062 10.8241C22.8771 10.8241 23.3246 11.0035 23.6513 11.3166C23.9773 11.629 24.1562 12.0481 24.1562 12.4803C24.1562 12.9126 23.9773 13.3316 23.6513 13.6441C23.3246 13.9572 22.8771 14.1366 22.4062 14.1366ZM29.9062 14.1366C29.4354 14.1366 28.9879 13.9572 28.6612 13.6441C28.3352 13.3316 28.1562 12.9126 28.1562 12.4803C28.1562 12.0481 28.3352 11.629 28.6612 11.3166C28.9879 11.0035 29.4354 10.8241 29.9062 10.8241C30.3771 10.8241 30.8246 11.0035 31.1513 11.3166C31.4773 11.629 31.6562 12.0481 31.6562 12.4803C31.6562 12.9126 31.4773 13.3316 31.1513 13.6441C30.8246 13.9572 30.3771 14.1366 29.9062 14.1366Z",
    fill: "#212529",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4300_47826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5,
    height: 16.3125,
    fill: "white",
    transform: "translate(12.6562 4.3241)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotdotdot);
export default __webpack_public_path__ + "static/media/dotdotdot.5dd46a35f9ecb00a7d7514671b942e3a.svg";
export { ForwardRef as ReactComponent };